import Swiper from "swiper";
import {
	Autoplay,
	EffectFade,
	FreeMode,
	Navigation,
	Pagination,
	Thumbs,
} from "swiper/modules";

if (document.querySelector(".banner1Slider")) {
	new Swiper(".banner1Slider", {
		modules: [Autoplay, EffectFade, Pagination],
		slidesPerView: 1,
		autoplay: true,
		loop: true,
		effect: "fade",
		speed: 1500,
		pagination: {
			el: ".banner1-pagination",
			clickable: true,
		},
	});
}
if (document.querySelector(".projectSlider")) {
	new Swiper(".projectSlider", {
		slidesPerView: "auto",
		autoplay: {
			delay:1
		},
		loop: true,		
		modules: [Autoplay],
		centeredSlides: true,
		spaceBetween:24,
		speed:8000,
		allowTouchMove:false
	});
}
if (document.querySelector(".team1Slider")) {
	new Swiper(".team1Slider", {
		slidesPerView:1,	
		loop: true,		
		modules: [Autoplay,Navigation],
		navigation:{
			prevEl:".prev-team",
			nextEl:".next-team",
		},
		spaceBetween:16,
		breakpoints:{
			768:{
				spaceBetween:24,
				slidesPerView:2
			}
		}
	});
}

if (document.querySelector(".testimonialSlider1")) {
	new Swiper(".testimonialSlider1", {
		slidesPerView:1,	
		loop: true,		
		modules: [Autoplay,Navigation],
		navigation:{
			prevEl:".prev-client",
			nextEl:".next-client",
		},
		spaceBetween:16,		
	});
}

if (document.querySelector(".portfolioSlider2")) {
	new Swiper(".portfolioSlider2", {
		slidesPerView: "auto",		
		loop: true,		
		modules: [Autoplay,Pagination],
		autoplay: true,
		centeredSlides: true,
		spaceBetween:24,	
		pagination:{
			el:".portfolio-pagination",
			clickable:true
		}
	});
}

if (document.querySelector(".testimonialSlider2")) {
	new Swiper(".testimonialSlider2", {
		slidesPerView:1,	
		loop: true,		
		modules: [Autoplay,Navigation],
		navigation:{
			prevEl:".prev-client",
			nextEl:".next-client",
		},
		spaceBetween:16,
		breakpoints:{
			920:{
				spaceBetween:24,
				slidesPerView:2
			}
		}		
	});
}

if (document.querySelector(".bannerSlider3")) {
	new Swiper(".bannerSlider3", {
		slidesPerView:1.2,	
		loop: true,		
		modules: [Autoplay],
		spaceBetween:16,
		centeredSlides:true,
		breakpoints:{
			768:{
				spaceBetween:24,
				slidesPerView:1.6
			},
			1200:{
				spaceBetween:24,
				slidesPerView:1.8
			},
			1600:{
				spaceBetween:24,
				slidesPerView:2.1
			},
		}		
	});
}

  // blog slider
  if (document.querySelector('.serviceSlider3')) {
    new Swiper('.serviceSlider3', {
      slidesPerView: 'auto',
      modules: [Autoplay],
      autoplay:true,
      spaceBetween: 24,
      loop: true,      
    })
  }


if (document.querySelector(".thumbSlider")) {
	// game details slider
	var swiper = new Swiper(".thumbSlider", {
		spaceBetween: 16,
		slidesPerView: 3,
		freeMode: true,
		modules: [Autoplay, Thumbs, FreeMode],
		autoplay: true,
		loop: true,
		watchSlidesProgress: true,
	});
	var swiper2 = new Swiper(".productSlider", {
		spaceBetween: 10,
		loop: true,
		autoplay: true,
		modules: [Autoplay, Thumbs],
		thumbs: {
			swiper: swiper,
		},
	});
}
